import { Cluster } from "@solana/web3.js";

/**
 * Custom RPC gate to get list of CM
 */
export const CM_CUSTOM_RPC: Partial<Record<Cluster, string | undefined>> = {
  // devnet: "https://psytrbhymqlkfrhudd.dev.genesysgo.net:8899/",
};
